module.exports = __webpack_public_path__ + "static/media/bg-princeton-univ-thumbnail.3508037b.jpeg";